import React from 'react';

import { Table, TableFilterModel } from 'design-library';

import { useHirer } from 'admin/hooks';
import { IHirer } from 'common/models';

import { UserActions } from './UserActions';

export const HirersTable = () => {
  const {
    isLoadingHirers,
    hirerResults,
    paginationModel,
    setPaginationModel,
    setQueryOptions,
  } = useHirer();

  const getFormattedRows = (hirers: Array<IHirer>) =>
    hirers.map((hirer) => ({
      ...hirer,
      actions: hirer,
    }));

  const onFilterChange = React.useCallback(
    (filterModel: TableFilterModel) => {
      setQueryOptions(
        filterModel.items.reduce(
          (acc, item) =>
            item.value ? { ...acc, [item.field]: item.value } : acc,
          {}
        )
      );
    },
    [setQueryOptions]
  );

  return (
    <Table
      columns={[
        {
          field: 'name',
          headerName: 'Hirer Name',
          width: 200,
        },
        {
          field: 'email',
          headerName: 'Email',
          width: 280,
        },
        {
          field: 'companyName',
          filterable: false,
          headerName: 'Company Name',
          width: 180,
        },
        {
          align: 'center',
          field: 'actions',
          filterable: false,
          headerAlign: 'center',
          headerName: 'Actions',
          renderCell: (params) => (
            <UserActions
              userId={params.value.id}
              isUserActive={params.value.isActive}
              role="hirer"
            />
          ),
          width: 200,
        },
      ]}
      loading={isLoadingHirers}
      paginationMode="server"
      onPaginationModelChange={setPaginationModel}
      paginationModel={paginationModel}
      pageSizeOptions={[paginationModel.pageSize]}
      rowCount={hirerResults.total}
      rows={getFormattedRows(hirerResults.data)}
      showToolbar
      slots={
        {
          // noRowsOverlay: () => <BidTableEmptyState />,
        }
      }
      filterMode="server"
      onFilterModelChange={onFilterChange}
    />
  );
};
